import { render, staticRenderFns } from "./MonitorTemplate.vue?vue&type=template&id=200bc0a3&scoped=true"
import script from "./MonitorTemplate.vue?vue&type=script&lang=js"
export * from "./MonitorTemplate.vue?vue&type=script&lang=js"
import style0 from "./MonitorTemplate.vue?vue&type=style&index=0&id=200bc0a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200bc0a3",
  null
  
)

export default component.exports